export default "__VITE_ASSET__CYg29_uJ__"